import produce from 'immer';
import { AnyAction } from 'redux';
import {
  UPDATE_RECEIPT_REQUEST,
  UPDATE_RECEIPT_SUCCESS,
  UPDATE_RECEIPT_FAILURE,
  UPDATE_RECEIPT_INITIAL,
} from '../../actions';

// タイプを設定
export type UpdateReceiptStateType = {
  isUpdateReceiptLoading: boolean;
  isUpdateReceiptLoaded: boolean;
  updateReceipt: UpdateReceiptType;
};

type UpdateReceiptType = {
  url: string;
  errorMessage: string;
};

// ステイタスを初期化
const initialState: UpdateReceiptStateType = {
  isUpdateReceiptLoading: false,
  isUpdateReceiptLoaded: false,
  updateReceipt: {
    url: '',
    errorMessage: '',
  },
};

// APIの結果によってステイタスが更新される処理
const updateReceiptReducer = (state = initialState, action: AnyAction): UpdateReceiptStateType => {
  return produce(state, (draft) => {
    const dataState = draft;
    switch (action.type) {
      case UPDATE_RECEIPT_REQUEST:
        dataState.isUpdateReceiptLoading = true;
        dataState.isUpdateReceiptLoaded = false;
        dataState.updateReceipt.url = '';
        dataState.updateReceipt.errorMessage = '';
        break;
      case UPDATE_RECEIPT_SUCCESS:
        dataState.isUpdateReceiptLoading = false;
        dataState.isUpdateReceiptLoaded = true;
        dataState.updateReceipt.url = action.res.data;
        dataState.updateReceipt.errorMessage = '';
        break;
      case UPDATE_RECEIPT_FAILURE:
        dataState.isUpdateReceiptLoading = false;
        dataState.isUpdateReceiptLoaded = false;
        dataState.updateReceipt.url = '';
        dataState.updateReceipt.errorMessage = action.error.message;
        break;
      case UPDATE_RECEIPT_INITIAL:
        dataState.isUpdateReceiptLoading = false;
        dataState.isUpdateReceiptLoaded = false;
        dataState.updateReceipt.url = '';
        dataState.updateReceipt.errorMessage = '';
        break;
      default:
        break;
    }
  });
};

export default updateReceiptReducer;
